import { defineStore } from 'pinia'
import * as api from '@/service/index'
import { useSessionStore } from './session'

const createState = () => ({
  player: '',
  videoLink: '',
  liveInfo: {},
  teamsInfo: [],
  schedule: [],
  maxViewTime: 10,
  isHintSchedule: false,
  isHintLive: true,
  config: {},
  seasonInfo: {},
  liveRoomList: [],
  force: false,
  showLingqu: {
    quizHots: {
      quizTop: 0
    },
    taskHots: {
      shopTop: 0
    }
  },
  dailyTasksList: [],
  mall: {
    goodsList: [],
    resident: []
  }
})

export const useBusinessStore = defineStore('business', {
  state: () => createState(),
  actions: {
    setConfig(config = {}) {
      this.config = config
      this.liveRoomList = config.roomLive || []
    },
    async reqTeamsList(data) {
      const teamsInfo = await api.reqTeamsList(data)
      this.teamsInfo = teamsInfo.data.teamLists

      return teamsInfo
    },
    async reqMatchSimpleSeasons() {
      const sessionStore = useSessionStore()
      if (!sessionStore.token) return

      const response = await api.reqMatchSimpleSeasons({ token: sessionStore.token })
      if (response.status === 200) {
        const seasonList = response.data
        this.seasonInfo = seasonList.find((item) => item.status === 1) || {}
      }

      return response
    },
    async reqRedDotState() {
      const sessionStore = useSessionStore()
      if (!sessionStore.token) return

      const response = await api.getRedDotState({ token: sessionStore.token })
      if (response.status === 200) {
        const info = response.data
        this.showLingqu = {
          quizHots: {
            quizTop: info.quizHots.quizTop
          },
          taskHots: {
            shopTop: info.taskHots.shopTop
          },
          ...info
        }
      }

      return response
    },
    async getGoodsList() {
      const sessionStore = useSessionStore()
      if (!sessionStore.token) return

      const response = await api.reqGoodsList({
        token: sessionStore.token
      })
      if (response.status === 200) {
        this.mall.goodsList = response.data.dailyGoods
        this.mall.resident = response.data.cumulGoods
      }

      return response
    }
  }
})
